// extracted by mini-css-extract-plugin
module.exports = {"starList":"styles_starList__TPRu8","star":"styles_star__IL3W5","filled":"styles_filled__6YhIK"};